function isRelativeFilterConditionValueType(filterConditionValueType) {
    if (filterConditionValueType === "RELATIVE_DAYS" ||
        filterConditionValueType === "RELATIVE_WEEKS" ||
        filterConditionValueType === "RELATIVE_MONTHS" ||
        filterConditionValueType === "RELATIVE_YEARS") {
        return true;
    }
    return false;
}
function getRelativeFilterConditionValueTypeDisplay(filterConditionValueType) {
    if (filterConditionValueType === "RELATIVE_DAYS") {
        return "day";
    }
    return "";
}
export { isRelativeFilterConditionValueType, getRelativeFilterConditionValueTypeDisplay, };
